import React, { useEffect, useState } from "react"
import { defineMessages, injectIntl } from "react-intl"
import UseModal from "../../../common/hooks/UseModal"
import { Intl } from "../../../state/helpers/IntlProps"
import { SerialNumberElastic } from "../../../state/listing/serial-numbers/models"
import SerialNumberFormComponent from "../form/SerialNumberFormComponent"


const messages = defineMessages({
    header_create: {
        id: "product.serial_number.modal.create.header",
        defaultMessage: "Create serial number"
    },
    header_edit: {
        id: "product.serial_number.modal.edit.header",
        defaultMessage: "Edit serial number"
    },
    create: {
        id: "product.serial_number.modal.edit.create",
        defaultMessage: "Create"
    },
    save: {
        id: "product.serial_number.modal.edit.save",
        defaultMessage: "Save"
    },
})

type Props = {
    intl: Intl
    serialNumberId?: string
    productId?: string
    serialNumber?: SerialNumberElastic
    onCloseCallback: () => void
    onSuccessCallback: () => void
}

const EditSerialNumberModal = (props: Props) => {
    const [isFormValid, setIsFormValid] = useState<boolean>(false)
    const [isFormActionLoading, setIsFormActionLoading] = useState<boolean>(false)
    const formId = `serial-number-${props.serialNumberId || "new"}`

    const body = <SerialNumberFormComponent
        serialNumberId={props.serialNumberId}
        productId={props.productId}
        serialNumber={props.serialNumber}
        formId={formId}
        onFormValidityUpdateCallback={(isFormValid: boolean) => {
            setIsFormValid(isFormValid)
        }}
        onActionSuccessCallback={() => {
            setTimeout(() => {
                props.onSuccessCallback()
            }, 1000)
        }}
        onActionErrorCallback={(err: Error) => {
            console.log("err: ", err.message)
        }}
        onActionLoadingCallback={(isLoading: boolean) => {
            setIsFormActionLoading(isLoading)
        }}
    />

    const { modal, hasClosed, setSubmitDisabled, setLoading } = UseModal({
        show: true,
        header: props.intl.formatMessage(props.serialNumberId ? messages["header_edit"] : messages["header_create"]),
        body: body,
        bodyStyle: { overflow: "visible" },
        confirmBtnType: "submit",
        confirmBtnFormId: formId,
        confirmBtnText: props.intl.formatMessage(props.serialNumberId ? messages["save"] : messages["create"])
    })

    useEffect(() => {
        setSubmitDisabled(!isFormValid)
    }, [isFormValid])

    useEffect(() => {
        setLoading(isFormActionLoading)
        setSubmitDisabled(isFormActionLoading ? true : !isFormValid)
    }, [isFormActionLoading])

    useEffect(() => {
        if (hasClosed) {
            props.onCloseCallback()
        }
    }, [hasClosed])

    return (
        <>
            {modal}
        </>
    )
}

export default injectIntl(EditSerialNumberModal)


// WEBPACK FOOTER //
// ./src/product/serial-number/modal/EditSerialNumberModal.tsx